// tenant api
import loadJsonAwsApiGenerator from './loadJsonAwsApiGenerator.api.tenant';

const getHaloScoresApi = (supplierId) =>
  loadJsonAwsApiGenerator(`halo-supplier-scores/${supplierId}`)();

export default getHaloScoresApi;
